/* eslint-disable react/prop-types */
//
import React from 'react';

import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import { Field, Form, Formik } from 'formik';
import { withStyles } from 'tss-react/mui';

import ChatBubble from '@mui/icons-material/ChatBubbleOutlineRounded';
import LockIcon from '@mui/icons-material/LockRounded';
import MailIcon from '@mui/icons-material/MailOutlineRounded';
import PhoneIcon from '@mui/icons-material/PhoneRounded';
import InputAdornment from '@mui/material/InputAdornment';

import FormikSelect from 'components/Formik/Select';

import showManageUpdatesDialog from 'components/Dialogs/ManageUpdatesDialog/dispatcher';
import StdDialogActions from 'components/Dialogs/StdDialogActions';
import StdDialogContent from 'components/Dialogs/StdDialogContent';
import StdDialogForm from 'components/Dialogs/StdDialogForm';

import { institutionLoginsTypes } from 'app-components/flux/institution-logins';

import { Select, TextField } from '@mui/material';
import TertiaryTrust from '../TertiaryTrust';
import styles from './styles';

class MfaChallengeForm extends React.PureComponent {
  formik = null;

  mountRef = { current: false };

  constructor(props) {
    super(props);
    this.mountRef = React.createRef();
    this.mountRef.current = false;
    const challenger = this.props.mfaChallenge.challenges;
    let value = null;
    let key = null;
    if (challenger) {
      const firstChallenge = challenger.first();
      if (firstChallenge && firstChallenge.answerChoices) {
        value = firstChallenge.answerChoices.first().displayText;
        key = firstChallenge.key;
      }
    }
    this.state = {
      value,
      key,
    };
  }

  componentDidMount() {
    this.mountRef.current = true;
    if (this.state.key && this.state.value) {
      this.formik?.setFieldValue(this.state.key, this.state.value);
    }
  }

  componentWillUnmount() {
    this.mountRef.current = false;
  }

  handleCancel = () => {
    const { onCancel } = this.props;

    if (onCancel) {
      onCancel({
        step: 'mfa',
      });
    }
  };

  handleManageUpdates = () => {
    const { institutionLogin } = this.props;
    showManageUpdatesDialog({ defaultValue: institutionLogin?.id });
  };

  handleGridChange = (event) => {
    this.setState({ value: event.target.value });
    this.formik?.setFieldValue(event.target.name, event.target.value);
  };

  handleSubmit = (values, _actions, mfaChallenge, onSubmit) => {
    const mfaResponse = institutionLoginsTypes.mkMfaResponse({
      institutionLoginId: mfaChallenge.institutionLoginId,
      answers: mfaChallenge.challenges.map((challenge) =>
        institutionLoginsTypes.mkMfaAnswer({
          id: challenge.key,
          value: values[challenge.key],
        }),
      ),
      submitUrl: mfaChallenge.submitUrl,
    });
    if (onSubmit) {
      onSubmit(
        mfaResponse,
        () => {
          if (this.mountRef.current) this.formik?.setSubmitting?.(false);
        },
        () => {
          if (this.mountRef.current) this.formik?.setSubmitting?.(false);
        },
      );
    }
  };

  generateLine = (displayText) => {
    const { classes } = this.props;
    const text = /(text)|(sms)/i.test(displayText);
    const email = /email/i.test(displayText);
    const call = /call/i.test(displayText) || /voice/i.test(displayText);
    const number = /\bXXX-XXX-(\d*)/i.exec(displayText);
    const mailDomain = /([a-zA-Z0-9*._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi.exec(displayText);
    if (text) {
      return (
        <div className={classes.messageLine}>
          <ChatBubble />
          {number ? (
            <>
              <Typography variant='paragraphRegular' className={classes.dropdownSpace} noWrap>
                Text
              </Typography>
              <Typography variant='paragraphRegular' className={classes.grayText} noWrap>
                {number ? number[0] : ''}
              </Typography>
            </>
          ) : (
            <Typography variant='paragraphRegular' className={classes.dropdownSpace} noWrap>
              {displayText}
            </Typography>
          )}
        </div>
      );
    }
    if (call) {
      return (
        <div className={classes.messageLine}>
          <PhoneIcon />
          {number ? (
            <>
              <Typography variant='paragraphRegular' className={classes.dropdownSpace}>
                Call
              </Typography>
              <Typography variant='paragraphRegular' className={classes.grayText}>
                {number ? number[0] : ''}
              </Typography>
            </>
          ) : (
            <Typography variant='paragraphRegular' className={classes.dropdownSpace} noWrap>
              {displayText}
            </Typography>
          )}
        </div>
      );
    }
    if (email) {
      return (
        <div className={classes.messageLine}>
          <MailIcon />
          {mailDomain ? (
            <>
              <Typography variant='paragraphRegular' className={classes.dropdownSpace}>
                Email
              </Typography>
              <Typography variant='paragraphRegular' className={classes.grayText}>
                {mailDomain ? mailDomain[0] : ''}
              </Typography>
            </>
          ) : (
            <Typography variant='paragraphRegular' className={classes.dropdownSpace} noWrap>
              {displayText}
            </Typography>
          )}
        </div>
      );
    }
    return (
      <div className={classes.messageLine}>
        <Typography variant='paragraphRegular' noWrap>
          {displayText}
        </Typography>
      </div>
    );
  };

  renderAnswerField = (key) => (
    <TextField
      fullWidth
      variant='filled'
      name={key}
      onChange={(event) => {
        this.formik?.setFieldValue(key, event.target.value);
      }}
      label='Answer'
      style={{ paddingRight: '20px' }}
      InputProps={{
        autoFocus: true,
        endAdornment: (
          <InputAdornment position='end'>
            <LockIcon style={{ color: '#706e6b' }} />
          </InputAdornment>
        ),
      }}
    />
  );

  renderChallenge = (challenge) => {
    const { classes, mfaChallenge } = this.props;
    const options = challenge.answerChoices && mfaChallenge.challenges.size === 1;
    return (
      <div className={classes.challenge} key={challenge.key}>
        {challenge.base64Image && (
          <Box display='flex' justifyContent='center'>
            <img alt='mfa' src={`data:image/jpeg;base64, ${challenge.base64Image}`} />
          </Box>
        )}
        <Typography variant='paragraphRegular' className={options ? classes.bigQuestion : classes.littleQuestion}>
          {challenge.question}
        </Typography>
        {challenge.answerChoices
          ? this.renderAnswerChoices(challenge.key, challenge.answerChoices)
          : this.renderAnswerField(challenge.key)}
      </div>
    );
  };

  renderAnswerChoices = (key, choices) => {
    const { classes } = this.props;
    return choices.size > 3 ? (
      <Select
        component={FormikSelect}
        fullWidth
        variant='filled'
        value={this.state.value}
        onChange={this.handleGridChange}
        name={key}
        input={<OutlinedInput id='key' labelWidth={0} />}
        MenuProps={{
          classes: {
            paper: classes.menu,
          },
        }}
      >
        {choices.map((choice) => (
          <MenuItem key={choice.displayText} value={choice.displayText}>
            {this.generateLine(choice.displayText)}
          </MenuItem>
        ))}
      </Select>
    ) : (
      <Field
        name={key}
        value={this.state.value}
        render={({ field }) => (
          <RadioGroup
            {...field}
            aria-label={key}
            name={key}
            value={this.state.value}
            onChange={this.handleGridChange}
            className={classes.answerGrid}
          >
            {choices.map((choice) => (
              <FormControlLabel
                key={choice.displayText}
                value={choice.displayText}
                control={<Radio />}
                label={<div className={classes.iconLine}>{this.generateLine(choice.displayText)}</div>}
                className={classes.formLabel}
              />
            ))}
          </RadioGroup>
        )}
      />
    );
  };

  renderForm = (formikBag) => {
    const { fiBrandingIndent, fullAddAccountsDialog, mfaChallenge } = this.props;
    const { handleSubmit: formikHandleSubmit, isSubmitting } = formikBag;
    this.formik = formikBag;

    const cancelButtonLabel = fullAddAccountsDialog ? null : 'Cancel';
    const submitButtonLabel = fullAddAccountsDialog ? 'Connect' : 'Submit';

    return (
      <StdDialogForm component={Form} onSubmit={formikHandleSubmit}>
        <StdDialogContent id='mfa_challenge_dialog' sx={{ pl: `${fiBrandingIndent}px` }}>
          {mfaChallenge.challenges.map((challenge) => this.renderChallenge(challenge))}
        </StdDialogContent>
        <StdDialogActions
          primary={{
            children: submitButtonLabel,
            disabled: isSubmitting,
          }}
          secondary={{
            children: !fullAddAccountsDialog && this.handleCancel ? cancelButtonLabel : 'Manage Updates',
            onClick: !fullAddAccountsDialog && this.handleCancel ? this.handleCancel : this.handleManageUpdates,
            variant: !fullAddAccountsDialog && this.handleCancel ? 'outlined' : 'text',
          }}
          tertiaryNode={fullAddAccountsDialog && <TertiaryTrust />}
        />
      </StdDialogForm>
    );
  };

  render() {
    const { mfaChallenge, onSubmit } = this.props;

    if (!mfaChallenge) {
      return null;
    }

    return (
      <Formik
        onSubmit={(values, actions) => this.handleSubmit(values, actions, mfaChallenge, onSubmit)}
        initialValues={{}}
      >
        {this.renderForm}
      </Formik>
    );
  }
}

export default withStyles(MfaChallengeForm, styles, { name: 'MfaChallengeForm' });
